import React, { useEffect, useState, Suspense} from 'react';
import './one-hotels.css'
import '../common/css/global.css';
const ImpactPage = React.lazy(() => import('./public-impact/one-hotels-impact'));
import OneHotels from './one-hotels.js';
import * as impact from '../common/api/impact';
import { Route, Switch} from "react-router-dom";

function App() {
  const merchantCode = 'SH_HOTELS';

  const [fetchedImpact, setFetchedImpact] = useState(null);

  useEffect(() => {
    impact.merchants(merchantCode)
      .then(response => response.json())
      .then(body => setFetchedImpact(body))
      .catch(error => {
        console.error(error);
        setFetchedImpact(error)
      })
  }, []);

  return (
    <>
      <Switch>
        <Route
          exact
          path={`/impact`}
          key="app-1h-impact"
        >
          <Suspense fallback={<div>Loading...</div>}>
                  <ImpactPage merchantCode={merchantCode} />
          </Suspense>       
         </Route>
        <Route
          path={`/`}
          key="app-entry-1h"
        >
          <OneHotels fetchedImpact={fetchedImpact} merchantCode={merchantCode} />
        </Route>
      </Switch>
    </>
  );
}

export default App;
